// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__mMrK3","name":"ConsentHeader_name__21wDb","birthday":"ConsentHeader_birthday__FDn8h","skeleton":"ConsentHeader_skeleton__VKU3W"};